// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator it_management`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

// eslint-disable-next-line factorial/no-allowed-mobx-collections
import companies from 'modules/core/store/collections/companies'
// eslint-disable-next-line factorial/no-allowed-mobx-collections
import legalEntities from 'modules/core/store/collections/legalEntities'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 3 cases in this module */,
    [legalEntities, {}] /* Referenced by 3 cases in this module */,
  ] /* Generated file 👉 artifacts/it_management-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
